import React, { useEffect, useState } from "react";
import { White } from "../../../Constants/ColorChart";
import FeatherIconWrapper from "../../Icons/FeatherIconWrapper";
import FileIcon from "../../Icons/File/File";
import { Container, Content, Item, Tab, TabBar } from "../Style/StyledRecentActivity";
import { formatDateAsDay, processAsResource } from "../../../../../web/Utils/utils";
import { saveAs } from "../../ResultTable/Components/ResultRow/ResultRow";
import { Link } from "react-router-dom";
import { useApolloClient } from "@apollo/client";
import { connect } from "react-redux";
import { RESOURCE_FOR_FREQUENTLY_USED_CONTENT_QUERY } from "../Queries/ResourceForFrequentlyUsedContent";


const RecentActivity = ({ recentActivityAPI , frequentlyUsedAPI , isNetworkAvailable, session }) => {
    const [ activeTab, setActiveTab ] = useState ( "lastUpdated" );
    const [ lastUpdatedContent, setContent ] = useState ( null );
    const [ frequentlyUsedContent, setFrequentlyUsedContent ] = useState ( null );
    const [frequentlyAPIError, setFrequentlyAPIError] = useState(null);
    const [lastUpdatedAPIError, setLastUpdatedAPIError] = useState(null);
    // View conditions
    const lastUpdatedContentAvailable = Array.isArray(lastUpdatedContent) && lastUpdatedContent.length > 0;
    const frequentlyUsedContentAvailable = Array.isArray(frequentlyUsedContent) && frequentlyUsedContent.length > 0;
    const noLastUpdatedContent =   Array.isArray(lastUpdatedContent) && lastUpdatedContent.length === 0;
    const noFrequentlyUsedContent =  Array.isArray(frequentlyUsedContent) && frequentlyUsedContent.length === 0;
    const lastUpdatedContentIsLoading = lastUpdatedContent === null;
    const frequentlyUsedContentIsLoading = frequentlyUsedContent === null;
    const [ frequentlyUsedResources, setFrequentlyUsedResources ] = useState([]);
    const client = useApolloClient();
    const fetchData = async (data) => {
        const { recentActivityAPI, frequentlyUsedAPI } = data;
        try {
            if (recentActivityAPI) {
                const contentFromAPI = await recentActivityAPI()
                    .catch((error) =>{
                        console.error("Error fetching last updated content from APIs." );
                        setLastUpdatedAPIError(error);
                });
                setContent(contentFromAPI);
            }
            if (frequentlyUsedAPI) {
                const contentFromAPI = await frequentlyUsedAPI()
                    .catch((error) =>{
                        console.error("Error fetching frequently used content from APIs." );
                        setFrequentlyAPIError(error);
                    });
                setFrequentlyUsedContent(contentFromAPI);
            }

        } catch (error) {
            console.error("Error fetching from APIs:", error);
        }
    }

    useEffect (  () => {
        fetchData({recentActivityAPI, frequentlyUsedAPI})
            .catch((error) => {
                console.error("Error fetching recent activity:", error);
            });

    }, [recentActivityAPI, frequentlyUsedAPI] );

    useEffect(() => {
        if (frequentlyUsedContentAvailable) {
            Promise.all(
                frequentlyUsedContent.map(item =>
                    client.query({
                        query: RESOURCE_FOR_FREQUENTLY_USED_CONTENT_QUERY,
                        variables: { id: String(item.node_id) },
                        fetchPolicy: "no-cache"
                    }).then(({ data }) => ({
                        ...item,
                        doc: processAsResource(data.nodeById)
                    }))
                )
            ).then(setFrequentlyUsedResources)
            .catch(setFrequentlyAPIError);
        }
    }, [frequentlyUsedContent, client]);

    return (
        <Container>
            <TabBar>
                <Tab
                    name={"Last Updated Content"}
                    active={ activeTab === "lastUpdated" }
                    onClick={ () => setActiveTab ( "lastUpdated" ) }
                    className={ "left" }
                >
                    Last Updated Content
                </Tab>
                <Tab
                    name={"Frequently Used"}
                    active={ activeTab === "frequentlyUsed" }
                    onClick={ () => setActiveTab ( "frequentlyUsed" ) }
                    className={ "right" }
                >
                    Frequently Used
                </Tab>
            </TabBar>
            <Content>
                { activeTab === "lastUpdated" ? (
                    <>
                        {lastUpdatedContentIsLoading && <Item>Loading last updated content...</Item>}
                        {lastUpdatedContentAvailable && lastUpdatedContent.map ( ( item, index ) => (
                            <Item key={ index }>
                                <FeatherIconWrapper
                                    lassName={ "FileIcon top-bar-icon" }
                                    color={ White }
                                    width="24px"
                                    iconStyle="stroke-width: 1.3px; margin-top: -2px;"
                                    Icon={ FileIcon }
                                />
                                <Link
                                    to={ (item.content_type === 'playlist' ? '/Playlist/' : '/link/') + item.node_id }
                                    style={ { width: '64.69%' } }
                                >
                                    <span className={"item-name"} style={ { width: "100%" } }>{ item.title }</span>
                                </Link>
                                <span className={"item-time"} > { formatDateAsDay(item.latest_at.date) }</span>
                            </Item>))}
                        { (noLastUpdatedContent || lastUpdatedAPIError) && <Item>No last updated content available</Item>}
                    </>
                ) : (
                    <>
                        {frequentlyUsedContentIsLoading && <Item>Loading frequently used content...</Item>}
                    { frequentlyUsedContentAvailable && frequentlyUsedResources.map((item, index) => (
                        <Item key={ index }>
                            <FeatherIconWrapper
                                className={ "FileIcon top-bar-icon" }
                                color={ White }
                                width="24px"
                                iconStyle="stroke-width: 1.3px; margin-top: -2px;"
                                Icon={ FileIcon }
                            />
                            {/* TODO DEFINE ROUTES OR USE CONSTANTS FOR LINKS */}
                            <Link
                                to={ '/link/' + item.node_id }
                                style={ { width: '72.58%' } }
                            >
                                <span className={"item-name"} style={ { width: "100%" } }>{ item.name }</span>
                            </Link>
                            <Link
                                to={ '/media/' + item.doc.media_uuid + '/download' }
                                onClick={ event => saveAs ( event, item.doc, 'frequently_used', isNetworkAvailable, session ) }
                            >
                                <span className={ "item-download-link" }> { item.activity_type }</span>
                            </Link>
                        </Item>
                    ) )
                    }
                    {(noFrequentlyUsedContent || frequentlyAPIError) && <Item>No frequently used content available</Item>}
                    </>

                ) }
            </Content>
        </Container>
    );
};

const mapStateToProps = ( state ) => ({
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    session: state.session,
});

export default connect(mapStateToProps) (RecentActivity);
